import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ISkillLevelGroup } from '../../components/skillLevelType/SkillLevelTypeInterfaces';

const GetSkillLevelGroups = ():{ skillLevelGroups: ISkillLevelGroup[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ISkillLevelGroup[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ISkillLevelGroup[], AxiosError>('/skillLevelType/getSkillLevelGroups',
    (url) => fetcher(url));

  return {
    skillLevelGroups: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetSkillLevelGroups;
